import {dispatchCrezuEvent, getCookie, setCookie, pushGTMEvent, successRedirectPrepare} from "./helpers";

function getRandomInt(min, max) {
  min = Math.ceil(min);
  max = Math.floor(max);
  return Math.floor(Math.random() * (max - min + 1)) + min;
}


function goToFeed() {
  successRedirectPrepare();
  var sub2 = '&sub2=feed'
  if (!is_iframe) {
    let externalUuid = (localStorage.getItem('leadId') || localStorage.getItem('lead_id')).split('-').join('')
    const hostname = window.location.hostname
    if (hostname === 'opinomia.com') {
      dispatchCrezuEvent('opinomiaFeedRedirect', {'leadId': externalUuid})
      return
    }
    let feedURL = window.feedURL || '/offers'
    let finalURL = `${feedURL}?sub1=${externalUuid}&sub2=feed`
    window.location.href = `https://crezu.net:8002/session` +
      `?domain=${hostname}` +
      `&country_id=${$('[name=country]').val()}` +
      `&lead_id=${externalUuid}` +
      `&type=1` +
      `&method=redirect` +
      `&pq=${finalURL}`
  } else {
    window.location.href = '/iframe/offers';
  }
}

function goToFeedPromo() {
  window.onbeforeunload = null;
  window.is_redirected = true;
  window.location.href = (window.location.href.indexOf('crezu.') > -1) ? '/feed_promo' : '/'
  pushGTMEvent({
    "event": "redirectedWithBadRecaptchaScore"
  });
}

export {
  goToFeed,
  goToFeedPromo
}
